/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { Billing } from '../../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    billing: Billing
}

const UpdatedInCell: FC<Props> = ({ billing }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {billing.updatedAt ? formatDateTime(billing.updatedAt.toString()) : 'N/A'}
        </a>
    </div>
)

export { UpdatedInCell }
